// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"06d57371","447":"47065662","472":"094caa60","567":"52a96c72","987":"b1dc5d6c"}[chunkId] + ".chunk.js";
};